import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { PeopleAndCultureDashboard } from './sections/PeopleAndCulture';

export const Route = createFileRoute('/console/$orgId/dashboard/people-and-culture')({
    component: RouteComponent,
});

function RouteComponent() {
    const { dashboards, refetchSignal } = useDashboardContext();

    return (
        <PeopleAndCultureDashboard
            key={refetchSignal.peopleAndCulture}
            loading={dashboards.loading.peopleAndCultureDashboard}
            data={dashboards.data.peopleAndCultureDashboard}
        />
    );
}
